"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.icons = void 0;
var phosphor_react_1 = require("phosphor-react");
var custom_1 = require("./custom");
exports.icons = {
    PencilSimple: phosphor_react_1.PencilSimple,
    PencilLine: phosphor_react_1.PencilLine,
    Plus: phosphor_react_1.Plus,
    Lightbulb: phosphor_react_1.Lightbulb,
    Tag: phosphor_react_1.Tag,
    UploadSimple: phosphor_react_1.UploadSimple,
    CaretLeft: phosphor_react_1.CaretLeft,
    CaretRight: phosphor_react_1.CaretRight,
    XCircle: phosphor_react_1.XCircle,
    XSquare: phosphor_react_1.XSquare,
    DownloadSimple: phosphor_react_1.DownloadSimple,
    ArrowLineUpRight: phosphor_react_1.ArrowLineUpRight,
    User: phosphor_react_1.User,
    UserCirclePlus: phosphor_react_1.UserCirclePlus,
    MapPinLine: phosphor_react_1.MapPinLine,
    WarningCircle: phosphor_react_1.WarningCircle,
    HighlighterCircle: phosphor_react_1.HighlighterCircle,
    Paperclip: phosphor_react_1.Paperclip,
    SpeakerHigh: phosphor_react_1.SpeakerHigh,
    ArrowLeft: phosphor_react_1.ArrowLeft,
    CalendarBlank: phosphor_react_1.CalendarBlank,
    Trash: phosphor_react_1.Trash,
    DotsThreeVertical: phosphor_react_1.DotsThreeVertical,
    DotsThreeCircle: phosphor_react_1.DotsThreeCircle,
    DotsThree: phosphor_react_1.DotsThree,
    CaretUp: phosphor_react_1.CaretUp,
    CaretDown: phosphor_react_1.CaretDown,
    ShareNetwork: phosphor_react_1.ShareNetwork,
    X: phosphor_react_1.X,
    WhatsappLogo: phosphor_react_1.WhatsappLogo,
    FacebookLogo: phosphor_react_1.FacebookLogo,
    TwitterLogo: phosphor_react_1.TwitterLogo,
    LinkedinLogo: phosphor_react_1.LinkedinLogo,
    YoutubeLogo: phosphor_react_1.YoutubeLogo,
    InstagramLogo: phosphor_react_1.InstagramLogo,
    Globe: phosphor_react_1.Globe,
    Phone: phosphor_react_1.Phone,
    Envelope: phosphor_react_1.Envelope,
    Checks: phosphor_react_1.Checks,
    Check: phosphor_react_1.Check,
    ArrowClockwise: phosphor_react_1.ArrowClockwise,
    ArrowsClockwise: phosphor_react_1.ArrowsClockwise,
    ArrowsIn: phosphor_react_1.ArrowsIn,
    ArrowsOut: phosphor_react_1.ArrowsOut,
    MapPin: phosphor_react_1.MapPin,
    ArrowDown: phosphor_react_1.ArrowDown,
    ArrowsDownUp: phosphor_react_1.ArrowsDownUp,
    ArrowUp: phosphor_react_1.ArrowUp,
    GearSix: phosphor_react_1.GearSix,
    Wrench: phosphor_react_1.Wrench,
    CheckSquare: phosphor_react_1.CheckSquare,
    CheckSquareOffset: phosphor_react_1.CheckSquareOffset,
    Cards: phosphor_react_1.Cards,
    SignOut: phosphor_react_1.SignOut,
    Swap: phosphor_react_1.Swap,
    CheckCircle: phosphor_react_1.CheckCircle,
    Circle: phosphor_react_1.Circle,
    ImageSquare: phosphor_react_1.ImageSquare,
    ListDashes: phosphor_react_1.ListDashes,
    ListNumbers: phosphor_react_1.ListNumbers,
    ListPlus: phosphor_react_1.ListPlus,
    List: phosphor_react_1.List,
    FileArrowUp: phosphor_react_1.FileArrowUp,
    VideoCamera: phosphor_react_1.VideoCamera,
    Quotes: phosphor_react_1.Quotes,
    SpeakerSimpleHigh: phosphor_react_1.SpeakerSimpleHigh,
    FilePdf: phosphor_react_1.FilePdf,
    MagnifyingGlass: phosphor_react_1.MagnifyingGlass,
    Eye: phosphor_react_1.Eye,
    EyeClosed: phosphor_react_1.EyeClosed,
    Minus: phosphor_react_1.Minus,
    TextHOne: phosphor_react_1.TextHOne,
    TextHTwo: phosphor_react_1.TextHTwo,
    TextHThree: phosphor_react_1.TextHThree,
    TextBolder: phosphor_react_1.TextBolder,
    TextItalic: phosphor_react_1.TextItalic,
    TextUnderline: phosphor_react_1.TextUnderline,
    ArrowRight: phosphor_react_1.ArrowRight,
    Sliders: phosphor_react_1.Sliders,
    Faders: phosphor_react_1.Faders,
    Code: phosphor_react_1.Code,
    SortDescending: phosphor_react_1.SortDescending,
    SortAscending: phosphor_react_1.SortAscending,
    Crosshair: phosphor_react_1.Crosshair,
    MicrophoneStage: phosphor_react_1.MicrophoneStage,
    File: phosphor_react_1.File,
    FolderSimple: phosphor_react_1.FolderSimple,
    FolderSimpleStar: phosphor_react_1.FolderSimpleStar,
    LinkSimple: phosphor_react_1.LinkSimple,
    Laptop: phosphor_react_1.Laptop,
    Info: phosphor_react_1.Info,
    DotsSixVertical: phosphor_react_1.DotsSixVertical,
    Bell: phosphor_react_1.Bell,
    UserSwitch: phosphor_react_1.UserSwitch,
    PlusMinus: phosphor_react_1.PlusMinus,
    SelectionAll: phosphor_react_1.SelectionAll,
    Activity: phosphor_react_1.Activity,
    Browsers: phosphor_react_1.Browsers,
    Cube: phosphor_react_1.Cube,
    Table: phosphor_react_1.Table,
    UserList: phosphor_react_1.UserList,
    Binoculars: phosphor_react_1.Binoculars,
    LightbulbFilament: phosphor_react_1.LightbulbFilament,
    Keyboard: phosphor_react_1.Keyboard,
    TextAa: phosphor_react_1.TextAa,
    ThumbsUp: phosphor_react_1.ThumbsUp,
    ChatText: phosphor_react_1.ChatText,
    SlackLogo: phosphor_react_1.SlackLogo,
    SquareHalf: phosphor_react_1.SquareHalf,
    SquareHalfBottom: phosphor_react_1.SquareHalfBottom,
    MagicWand: phosphor_react_1.MagicWand,
    CrownSimple: phosphor_react_1.CrownSimple,
    Funnel: phosphor_react_1.Funnel,
    ThumbsDown: phosphor_react_1.ThumbsDown,
    CopySimple: phosphor_react_1.CopySimple,
    PaperPlaneRight: phosphor_react_1.PaperPlaneRight,
    Warning: phosphor_react_1.Warning,
    Star: phosphor_react_1.Star,
    ArrowsVertical: phosphor_react_1.ArrowsVertical,
    CirclesFour: phosphor_react_1.CirclesFour,
    ArrowLineDown: phosphor_react_1.ArrowLineDown,
    PaperPlaneTilt: phosphor_react_1.PaperPlaneTilt,
    NotePencil: phosphor_react_1.NotePencil,
    CircleNotch: phosphor_react_1.CircleNotch,
    PaintBucket: phosphor_react_1.PaintBucket,
    //custom icons
    OkeGoogleIcon: custom_1.OkeGoogleIcon,
    LetterH: custom_1.LetterH,
    IndexIcon: custom_1.IndexIcon,
    LanguageIcon: custom_1.LanguageIcon,
    BadgeAdmin: custom_1.BadgeAdmin,
    BadgeSuperAdmin: custom_1.BadgeSuperAdmin,
    BadgeMod: custom_1.BadgeMod,
    BadgeVetted: custom_1.BadgeVetted,
    IndiaFlag: custom_1.IndiaFlag,
    KenyaFlag: custom_1.KenyaFlag,
    SenegalFlag: custom_1.SenegalFlag,
    NigeriaFlag: custom_1.NigeriaFlag,
    MultipleImages: custom_1.MultipleImages,
    ModalBulbIcon: custom_1.ModalBulbIcon,
    Location14: custom_1.Location14,
    Person14: custom_1.Person14,
    Index: custom_1.Index,
    Download__nofill: custom_1.Download__nofill,
    Download: custom_1.Download,
    UploadSM: custom_1.UploadSM,
    AddXS: custom_1.AddXS,
    EditSM: custom_1.EditSM,
    Facebook_solid_SM: custom_1.Facebook_solid_SM,
    Linkedin_solid_SM: custom_1.Linkedin_solid_SM,
    Twitter_solid_SM: custom_1.Twitter_solid_SM,
    Instagram_solid_SM: custom_1.Instagram_solid_SM,
    Youtube_solid_SM: custom_1.Youtube_solid_SM,
    Mail_solid_SM: custom_1.Mail_solid_SM,
    Phone_solid_SM: custom_1.Phone_solid_SM,
    Website_solid_SM: custom_1.Website_solid_SM,
    KebabMenu: custom_1.KebabMenu,
    UploadImage: custom_1.UploadImage,
    Close_S: custom_1.Close_S,
    Settings_SM: custom_1.SettingsSM,
    BoldBtn: custom_1.BoldBtn,
    ItalicBtn: custom_1.ItalicBtn,
    UnderlineBtn: custom_1.UnderlineBtn,
    LinkIcon: custom_1.LinkIcon,
    RichFormatToolBlockquote: custom_1.RichFormatToolBlockquote,
    RichFormatToolH2: custom_1.RichFormatToolH2,
    RichFormatToolUnorderedList: custom_1.RichFormatToolUnorderedList,
    RichFormatToolOrderedList: custom_1.RichFormatToolOrderedList,
    PDFIcon: custom_1.PDFIcon,
    Attachment2: custom_1.Attachment2,
    VideoEmbedIcon: custom_1.VideoEmbedIcon,
    AudioEmbedIcon: custom_1.AudioEmbedIcon,
    IndonesiaFlag: custom_1.IndonesiaFlag,
    ArgentinaFlag: custom_1.ArgentinaFlag,
    USAFlag: custom_1.USAFlag,
    UKFlag: custom_1.UKFlag,
    MalaysiaFlag: custom_1.MalaysiaFlag,
    BrazilFlag: custom_1.BrazilFlag,
    ColombiaFlag: custom_1.ColombiaFlag,
    ChileFlag: custom_1.ChileFlag,
    PakistanFlag: custom_1.PakistanFlag,
    SpainFlag: custom_1.SpainFlag,
    Stars: custom_1.Stars,
    Celebrate: custom_1.Celebrate,
    Inspiring: custom_1.Inspiring,
    Learning: custom_1.Learning,
    Like: custom_1.Like,
    Reactions: custom_1.Reactions,
    WarningDiamond: custom_1.WarningDiamond
};
